import { render, staticRenderFns } from "./UberMenuCopy.vue?vue&type=template&id=af71a12e&scoped=true"
import script from "./UberMenuCopy.vue?vue&type=script&lang=js"
export * from "./UberMenuCopy.vue?vue&type=script&lang=js"
import style0 from "./UberMenuCopy.vue?vue&type=style&index=0&id=af71a12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af71a12e",
  null
  
)

export default component.exports